import api from './api';

export const listMyRequests = () =>
  api.get('/members/me/requests').then(r => r.data.requests);

export const createRequest = ({ category, subject, body }) =>
  api.post('/members/me/requests', { category, subject, body }).then(r => r.data.request);
